import TacheDetailController from './tache.detail.controller';

export default {
    template: require('./tache.detail.html'),
    controller: TacheDetailController
};
